import api from '@/utils/api/index'

export const actions = {
  async requestSubmitNominee(_, { payload, captchaKey }) {
    const settings = {
      headers: { GoogleCaptchaResponseKey: captchaKey }
    }

    await this.$axios.post(api.nominees.submitNominee(), payload, settings)
  }
}
